import { formatParsedMenu, toMenuTitleCase } from './menuTextFormat';

function isPriceToken(token) {
  return /^[$£€]?\d+(?:\.\d{1,2})?$/.test(token) || /^\d+\/\d+$/.test(token);
}

function normalizePrice(token) {
  if (!token) return '';
  if (token.includes('/')) return token;
  if (token.startsWith('$') || token.startsWith('£') || token.startsWith('€')) return token;
  return `$${token}`;
}

function looksLikeCategory(line) {
  if (!line) return false;
  if (isPriceToken(line)) return false;
  return /^[A-Za-z][A-Za-z0-9 &/+-.,]+$/.test(line);
}

function splitItemLine(line) {
  const match = line.match(/^(.*?)(?:\s+(\$?\d+(?:\.\d{2})?|\d+\/\d+))$/);
  if (!match) return null;

  const name = match[1].trim();
  const price = normalizePrice(match[2].trim());
  if (!name) return null;

  return { name, price };
}

export function parseMenuTextLocally(text) {
  const lines = text
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(Boolean);

  const categories = [];
  let currentCategory = { name: 'Menu', items: [] };
  let pendingItem = null;

  const pushPendingItem = () => {
    if (!pendingItem) return;
    currentCategory.items.push(pendingItem);
    pendingItem = null;
  };

  // Check if any line contains a price
  const hasPrices = lines.some(line => line.split(/\s+/).some(token => isPriceToken(token)));

  lines.forEach(line => {
    const parsedItem = splitItemLine(line);

    if (looksLikeCategory(line) && !parsedItem) {
      pushPendingItem();
      if (currentCategory.items.length > 0) {
        categories.push(currentCategory);
      }
      currentCategory = { name: toMenuTitleCase(line), items: [] };
      return;
    }

    if (parsedItem) {
      pushPendingItem();
      pendingItem = {
        name: toMenuTitleCase(parsedItem.name),
        description: '',
        price: parsedItem.price
      };
      return;
    }

    // If no prices in text, treat non-category lines as items without prices
    if (!hasPrices && line && !looksLikeCategory(line)) {
      pushPendingItem();
      pendingItem = {
        name: toMenuTitleCase(line),
        description: '',
        price: ''
      };
      return;
    }

    if (pendingItem) {
      pendingItem.description = pendingItem.description
        ? `${pendingItem.description} ${line}`
        : line;
    }
  });

  pushPendingItem();
  if (currentCategory.items.length > 0) {
    categories.push(currentCategory);
  }

  return formatParsedMenu({
    categories: categories.length > 0 ? categories : [{ name: 'Menu', items: [] }]
  });
}
